import React from 'react';
import { ContractAmbiguityFlagCard } from './ContractAmbiguityFlagCard';
import type { AmbiguityFinding } from '../../services/api';

interface ContractAmbiguityFlagsListProps {
  findings: AmbiguityFinding[];
  selectedSectionKey: string | null;
}

export const ContractAmbiguityFlagsList: React.FC<ContractAmbiguityFlagsListProps> = ({
  findings,
  selectedSectionKey,
}) => {
  const filtered = selectedSectionKey
    ? findings.filter(
        (f) => `${f.articleNumber}-${f.sectionNumber}` === selectedSectionKey
      )
    : findings;

  if (filtered.length === 0) {
    return (
      <div className="text-center py-12 text-gray-400" data-testid="no-findings">
        {selectedSectionKey
          ? 'No findings in this section.'
          : 'No ambiguity findings. Run the analysis to scan for ambiguous language.'}
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="ambiguity-flags-list">
      {filtered.map((finding) => (
        <ContractAmbiguityFlagCard key={finding.id} finding={finding} />
      ))}
    </div>
  );
};
